import React, { useState, useEffect, useRef } from "react";
import MuscleRecordUX from "./MuscleRecordUX";
import { Button, Icon, Modal, Form } from "semantic-ui-react";
import ModalEditImage from "react-lib/apps/common/ModalEditImage";
import MuscleTMJExamUX from "../MuscleTMJExamUX";
import ExaminationImageOverlay, { Tooltip } from "./ExaminationImageOverlay";

import { getClinicalTagColor, getClinicalTagMergeColor } from "./FaceRecord";

const MUSCLE_TMJ = "Muscle & TMJ";

const MuscleRecord = (props) => {
  const [openGallery, setOpenGallery] = useState(false);
  const [openPhysicalExam, setOpenPhysicalExam] = useState(false);
  let tooltipRef = useRef() as any;

  const handleClick = (key) => () => {
    console.log("handleClick key: ", key);
    if (props.selectorMode) {
      const organMaster = props.masterData?.organ?.items.filter((item) => item.hasOwnProperty("settingKey"));
      // console.log(" handleClick organMaster ", organMaster)
      let organ = organMaster.filter((item) => item.settingKey === key);
      // console.log(" handleClick organ ", organ)

      if (organ.length === 1) {
        props.onEvent({ message: "ToggleLocation", params: { items: [{ location: organ[0].nickName }] } });
      } else {
        console.log(" should not see me.");
      }
    }
  };

  const handleMouseOver = (e: any, key: string) => {
    tooltipRef?.show?.({
      target: e.target,
      key,
      masterData: props.masterData,
      selector: ".muscle-area .ui.form.svg-zoom-out",
    });
  };

  const handleMouseLeave = () => {
    tooltipRef.current.style.display = "none";
  };

  let settings = Object.assign({}, defaultSettings);
  // console.log(props.clinicalFindings);
  const clinicalTagsItems = props.masterData.clinicaltags?.items;
  const organMaster = props.masterData?.organ?.items.filter((item) => item.hasOwnProperty("settingKey"));
  const clinical = props.clinicalFindings.find((item) => item.id === props.clinicalFindingId);
  const targetLocation = clinical?.location?.split(",").map((item) => item.trim()) || [];
  const targetClinicaltags = clinical?.clinicaltags?.split(",").map((item) => item.trim()) || [];
  const findClinicalTag = clinicalTagsItems?.find((data) => targetClinicaltags.includes(data.name) && data.diagram === "noteeth");
  let previousList: any[] = [];

  // console.log("OrganMaster ", organMaster);
  for (const item of props.clinicalFindings) {
    let locationList = item?.location?.split(",").map((item) => item.trim()) || [];
    let clinicaltagsList = item?.clinicaltags?.split(",").map((item) => item.trim()) || [];
    for (const keyNickName of locationList) {
      let organ = organMaster.filter((item) => item.nickName === keyNickName);

      if (organ?.length > 0) {
        organ.forEach((element) => {
          let color = "transparent";
          //key ตรงกับ clinical ที่ active อยู่
          if (findClinicalTag && targetLocation?.includes(keyNickName)) {
            // color = findClinicalTag.color[0];
            color = getClinicalTagColor(clinicalTagsItems, targetClinicaltags);
          } else if (targetLocation?.includes(keyNickName)) {
            color = "orange";
          }
          if (!props.clinicalFindingId) {
            const findClinicaltags = clinicalTagsItems?.find((data: any) => clinicaltagsList.includes(data.name) && data.diagram === "noteeth");

            if (findClinicaltags) {
              const data = getClinicalTagMergeColor({
                clinicalTagsItems,
                clinicaltagsList,
                previousList,
                findClinicaltags,
                keyNickName,
                color,
              });

              color = data.color;
              previousList = data.previousList;
            } else if (locationList?.includes(keyNickName)) {
              color = "orange";
            }
          }

          settings[element.settingKey] = {
            ...settings[element.settingKey],
            fill: color,
            opacity: "0.7",
          };
        });
      }

      // if (organ.length > 0 ) {
      //   // if (Object.keys(defaultSettings).includes(keyNickName)) {

      //       settings[organ[0].settingKey] = {
      //         ...settings[organ[0].settingKey],
      //         fill: "orange",
      //         opacity: "0.7"
      //       }

      //   // }
      // }
    }
  }

  for (const key in defaultSettings) {
    if (Object.prototype.hasOwnProperty.call(defaultSettings, key)) {
      settings[key] = {
        ...settings[key],
        onClick: handleClick(key),
        style: { pointerEvents: "auto" },
        onMouseOver: (e) => {
          handleMouseOver(e, key);
        },
        onMouseLeave: (e) => {
          handleMouseLeave(e, key);
        },
      };
    }
  }

  // console.log("settings", settings);

  return (
    <div
      className="muscle-area"
      style={{ ...{ cursor: props.selectorMode ? "cell" : "default" }, padding: "0px 0px", display: "flex" }}
      onMouseDown={(e: any) => {
        if (props.selectorMode) {
          e.preventDefault();
        }
      }}
    >
      <Form className="svg-zoom-out">
        <ExaminationImageOverlay
          imageKey="muscle"
          sub={props.sub}
          historyReviewSubTab={props.historyReviewSubTab}
          clinicalFindings={props.clinicalFindings}
          filterClinicalFindingIds={props.filterClinicalFindingIds}
          showDrawingChecked={props.showDrawingChecked}
          hideTooltip={true}
          firstPosition={true}
        >
          <MuscleRecordUX settings={settings} />
        </ExaminationImageOverlay>
      </Form>

      <Tooltip ref={(ref) => (tooltipRef = ref || { current: null })} />

      {props.activeEvaluation ? (
        <Modal
          onClose={() => props.setProp("activeEvaluation", "")}
          // onOpen={() => setOpenPhysicalExam(true)}
          open={props.activeEvaluation === MUSCLE_TMJ}
          className="modal-muscle-tmj-exam"
        >
          {" "}
          <MuscleTMJExamUX
            muscleExamData={props.muscleExamData}
            onEvent={props.onEvent}
            setProp={props.setProp}
            handleSaveMuscleExam={() => {
              props.onEvent({ message: "SaveEvaluationForm", params: { form: "muscleExamData" } });
              props.setProp("activeEvaluation", "");
            }}
          />{" "}
        </Modal>
      ) : null}
    </div>
  );
};

export default MuscleRecord;

const defaultSettings = {
  muscle1: { fill: "transparent", stroke: "green" },
  muscle2: { fill: "transparent", stroke: "green" },
  muscle3: { fill: "transparent", stroke: "green" },
  muscle4: { fill: "transparent", stroke: "green" },
  muscle5: { fill: "transparent", stroke: "green" },
  muscle6: { fill: "transparent", stroke: "green" },
  muscle7: { fill: "transparent", stroke: "green" },
  muscle8: { fill: "transparent", stroke: "green" },
  muscle9: { fill: "transparent", stroke: "green" },
  muscle10: { fill: "transparent", stroke: "green" },
  muscle11: { fill: "transparent", stroke: "green" },
  muscle12: { fill: "transparent", stroke: "green" },
  muscle13: { fill: "transparent", stroke: "green" },
  muscle14: { fill: "transparent", stroke: "green" },
  muscle15: { fill: "transparent", stroke: "green" },
  muscle16: { fill: "transparent", stroke: "green" },
};
